import { render, staticRenderFns } from "./Periodos.vue?vue&type=template&id=25aaa63b&"
import script from "./Periodos.vue?vue&type=script&lang=js&"
export * from "./Periodos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports